export default __webpack_public_path__ + "static/media/metamask-fox.min.1be92651.svg";